// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"GM-z","inlineTitle":"HM-z","sponsoredAdsWrapper":"IM-z","marketplaceRecosWrapper":"JM-z"};